module.exports = __webpack_public_path__ + "static/media/mobileScreenshot09.fd30673e.jpg";